<div class="iframe-wrapper">
  <div class="iframe-overlay" *ngIf="!channelReady">
    <ngx-spinner [fullScreen]="false" bdColor="#0E2CE280" size="medium" name="iframeLoadingSpinner"
                 type="ball-clip-rotate-multiple"><p style="color: white"> Loading... </p></ngx-spinner>
  </div>
  <iframe (load)="iframeLoaded()" [src]="sanitizedClientUrl" allowfullscreen=""
          loading="lazy" title="client content"></iframe>
</div>
